"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BundleDomain;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _sharedComponents = require("@site/shared-components");
var _domainSearchUrlHelper = require("../../utils/domainSearchUrlHelper");
function BundleDomain(props) {
  const {
    DotTypesText,
    OfferSld,
    extensionColorClassName = 'text-primary',
    textClassName = '',
    fontSizeClassName = '',
    isDesktop = false,
    showAestheticBundleDomain = false
  } = props;
  const mainDomain = OfferSld;
  const fontSize = fontSizeClassName || mainDomain?.length > 12 || !isDesktop ? 'ms5' : 'ms9';
  const listOfTlds = (0, _domainSearchUrlHelper.getTldListFromDotTypesText)({
    DotTypesText,
    mainDomain
  });
  const tldList = listOfTlds?.map((tld, index, arr) => {
    const separator = index !== arr.length - 1 ? /*#__PURE__*/_react.default.createElement("span", {
      className: "font-weight-normal ms2"
    }, "\xA0+\xA0") : '';
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: tld
    }, /*#__PURE__*/_react.default.createElement("li", {
      className: (0, _classnames.default)('d-inline-block ux-card bundle-tld mb-0', {
        'px-1 ms3': !showAestheticBundleDomain,
        [extensionColorClassName]: !showAestheticBundleDomain,
        'mt-1 stack-bundle-tdl-item stack-bundle-tld-text': showAestheticBundleDomain,
        'mr-1 p-1': !isDesktop && showAestheticBundleDomain,
        'mr-2 p-2': isDesktop && showAestheticBundleDomain
      })
    }, tld), !showAestheticBundleDomain && separator);
  });
  const StackBundleList = /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('font-weight-bold d-flex', {
      'align-items-end ms3': !showAestheticBundleDomain,
      'align-items-start flex-column w-100': showAestheticBundleDomain
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "card-bundle-domain-main",
    "data-testid": "card-bundle-domain-main",
    className: "d-inline-block mx-1 "
  }, showAestheticBundleDomain ? /*#__PURE__*/_react.default.createElement(_sharedComponents.TwoToneDomain, (0, _extends2.default)({}, props, {
    names: [mainDomain],
    extensions: []
  })) : mainDomain), showAestheticBundleDomain && /*#__PURE__*/_react.default.createElement("hr", {
    className: (0, _classnames.default)('w-100', {
      'my-1': !isDesktop,
      'my-2': isDesktop
    })
  }), /*#__PURE__*/_react.default.createElement("ul", {
    "data-cy": "card-bundle-domain-list",
    "data-testid": "card-bundle-domain-list",
    className: "list-unstyled d-inline-block mb-0 card-bundle-domain-list"
  }, tldList));
  const textClassnames = textClassName || (0, _classnames.default)('font-weight-semibold', {
    'mb-1': isDesktop,
    'mb-0': !isDesktop
  });
  return /*#__PURE__*/_react.default.createElement("h2", {
    "data-cy": "card-bundle-domain",
    "data-testid": "card-bundle-domain",
    dir: "ltr",
    className: (0, _classnames.default)(`mx-0 d-inline-block break-text-anywhere my-2 ${textClassnames}`, {
      [fontSize]: !showAestheticBundleDomain,
      'w-100': showAestheticBundleDomain
    })
  }, StackBundleList);
}
BundleDomain.propTypes = {
  DotTypesText: _propTypes.default.string,
  OfferSld: _propTypes.default.string,
  extensionColorClassName: _propTypes.default.string,
  textClassName: _propTypes.default.string,
  fontSizeClassName: _propTypes.default.string,
  isDesktop: _propTypes.default.bool,
  showAestheticBundleDomain: _propTypes.default.bool
};